const categoryServiceName = "/Category";

export function categoryService (http) {
    return {
        getAllCategoriesAsync: async (userId) => {
            let data = {
                params: {
                    userId
                }
            };              
            return await http.get(categoryServiceName + '/GetAllCategoriesAsync', data);
        }
    }
}
